import { connect } from "react-redux";
import IAppState from "../../../../redux/types/IAppState";
import { resetPagination, searchCueSheetsSuccess, searchRegisteredSetListsSuccess, updatePagination } from "../../../../redux/reducers/MembersPortalReducer";
import { Dispatch } from "redux";
import UnpaidClaimsProductSearchModalView from "./UnpaidClaimsProductSearchModalView";
import { claimUnpaidUsageThunk, searchCueSheetsThunk, searchRegisteredSetListsThunk } from "../../../../redux/thunks/MembersPortalThunks";
import { IClaimUnidentifiedClaimModal } from "../../../../membersportal/types/IClaimUnidentifiedClaimModal";
import { ICueSheetsSearchQuery } from "../../../../membersportal/types/ICueSheetsSearchQuery";
import { IRegisteredSetListsSearchQuery } from "../../../../membersportal/types/IRegisteredSetListsSearchQuery";
import { SEARCH_VIEW_MEMBER_UNPAID_CLAIMS_PRODUCT_SEARCH } from "../../../../membersportal/Consts";

export default connect(
    (state: IAppState) => ({
        indexOfFirstResult: state.membersPortal.resultsPerPage.filter(x => x.repertoireSection === SEARCH_VIEW_MEMBER_UNPAID_CLAIMS_PRODUCT_SEARCH)[0]?.indexOfFirstResult,
        indexOfLastResult: state.membersPortal.resultsPerPage.filter(x => x.repertoireSection === SEARCH_VIEW_MEMBER_UNPAID_CLAIMS_PRODUCT_SEARCH)[0]?.indexOfLastResult,
        resultsPerPage: state.membersPortal.resultsPerPage.filter(x => x.repertoireSection === SEARCH_VIEW_MEMBER_UNPAID_CLAIMS_PRODUCT_SEARCH)[0]?.resultsPerSection,
        cueSheetsSearchResults: state.membersPortal.tabs[state.membersPortal.activeTab]?.cueSheetsSearchResults,
        setListsSearchResults: state.membersPortal.tabs[state.membersPortal.activeTab]?.registeredSetListsSearchResult, searchSuccessful: state.membersPortal.searchSuccessful,
        currentUserNameNumber: state.account.currentUserNameNumber,
        fields: state.membersPortal.componentData.UnpaidClaimsRegisteredWorksSearch.fields,
        lookupValues: state.lookupEntities,
        isSearching: state.membersPortal.isSearching,
    }),
    (dispatch: Dispatch) => ({
        claimUnpaidUsage: (query: IClaimUnidentifiedClaimModal) =>
            dispatch<any>(claimUnpaidUsageThunk(query)),
        clearProductSearch: () => {
            dispatch(searchCueSheetsSuccess(undefined));
            dispatch(searchRegisteredSetListsSuccess(undefined));
        },
        searchCueSheets: (query: ICueSheetsSearchQuery) =>
            dispatch<any>(searchCueSheetsThunk(query, false, 'ViewMyRegisteredCueSheets', true)),
        searchSetLists: (query: IRegisteredSetListsSearchQuery) =>
            dispatch<any>(searchRegisteredSetListsThunk(query, 'ViewMyRegisteredSetLists')),
        resetPagination: (repertoireSection: string) => dispatch(resetPagination(repertoireSection)),
        updatePagination: (indexOfFirstResult: number, indexOfLastResult: number, resultsPerPage: number, currentPage: number, repertoireSection: string) => dispatch<any>(updatePagination(indexOfFirstResult, indexOfLastResult, resultsPerPage, currentPage, repertoireSection)),
    })
)
    (UnpaidClaimsProductSearchModalView);
